import React, { useState } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Icon } from 'components';
import { Row, Col, Button, Alert, Icon as AntIcon, Modal, Form, InputNumber } from 'antd';

import classes from '../styles/teacher/TeacherInfo.module.scss';
import { formatNumber, formatRating } from 'utils/formatting';
import { Link } from 'react-router';
import { editTeacher } from 'data/teacher';
import DiscountTeacherModal from './DiscountTeacher';
const FormItem = Form.Item;

const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};
const formatVerifiedStatus = (status) => {
  let verifiedStatus;
  switch (status) {
    case 'verified':
      verifiedStatus = 'Yes';
      break;
    // case 'pending':
    //   verifiedStatus = 'Pending';
    //   break;
    case 'submitted':
      verifiedStatus = 'Pending';
      break;
    default:
      verifiedStatus = 'No';
      break;
  }
  return verifiedStatus;
};

const TeacherHeader = ({ teacher = {}, Tabs, onOpenDiscountModal, onOpenBanModal, form, reload }) => {
  const [isShowFeeModal, setFeeModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const registerDate = moment(teacher.createdAt).format('DD/MM/YYYY');
  let isRenderDiscount = false;
  const feeDiscountExpired = moment(teacher.feeDiscountExpired).format('D MMM YYYY');
  const feeDiscountRemaining = teacher.feeDiscountRemaining;
  const feeDiscount = teacher.feeDiscount;
  if (feeDiscountRemaining > 0 && feeDiscount > 0) {
    isRenderDiscount = true;
  }
  const verifiedStatus = formatVerifiedStatus(teacher.verifyStatus === 'pending' ? 'submitted' : teacher.verifyStatus);
  const bookbankVerifiedStatus = formatVerifiedStatus(teacher.bankAccountStatus);
  const taxInformationStatus = formatVerifiedStatus(teacher.taxInformation.status);

  const onUpdateFee = (e) => {
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        try {
          setLoading(true);
          await editTeacher(teacher._id, { feePercentage: values.feePercentage });
          await reload();
          setFeeModal(false);
          setLoading(false);
        } catch (err) {
          alert(err);
          setLoading(false);
        }

        console.log('Received values of form: ', values);
      }
    });
  };

  return (
    <div className={cn('content-header', classes.headerContainer)}>
      {teacher.isBan && <Alert message="Banned" type="error" description={' '} />}
      <Row>
        <Col xs={24}>
          <div className="pull-right">
            <Button type="danger" onClick={onOpenBanModal}>
              {teacher.isBan ? 'Unban' : 'Ban'}
            </Button>
          </div>
          <div className="header-title">
            <span className="bold">Teacher: </span>
            {`${teacher.name.first} ${teacher.name.last} `}
            {teacher.verified && <AntIcon type="check-circle" className="text-primary" />}
            <Icon name={`tp-level-${teacher.level}`} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <div className={classes.imageContainer}>
            <img className={cn(classes.profileImage)} src={`${teacher.displayImage}?${new Date().getTime()}`} />
          </div>
        </Col>
        <Col xs={8}>
          <div>
            <span className="bold">Display Name:</span> {teacher.displayName}
          </div>
          <div>
            <span className="bold">Teacher No.:</span> {teacher.teacherCode}
          </div>
          <div>
            <span className="bold">Register Date: </span>
            {registerDate}
          </div>
          <div>
            <span className="bold">Acc. Revenue: </span>
            {formatPrice(teacher.totalRevenue)}
          </div>
          <div>
            <span className="bold">Transferable: </span>
            {formatPrice(teacher.retainedEarning)}
          </div>
        </Col>
        <Col xs={5}>
          <div>
            <span className="bold">Verification: </span> {verifiedStatus}
          </div>
          <div>
            <span className="bold">Bank info: </span> {bookbankVerifiedStatus}
          </div>
          <div>
            <span className="bold">Tax info: </span> {taxInformationStatus}
          </div>
          <div>
            <span className="">
              <Link to={`/student/${teacher.user._id}`}>Student profile</Link>{' '}
            </span>{' '}
          </div>
        </Col>
        <Col xs={8}>
          <div className={classes.headerInfoBox}>
            <div className={cn(classes.topLeft, classes.box)}>
              <div className="bold">Completion</div>
              {formatNumber(teacher.finishedCourseCount, '0,0')}
            </div>
            <div className={cn(classes.topRight, classes.box)}>
              <div className="bold">Followers</div>
              {formatNumber(teacher.followerCount, '0,0')}
            </div>
            <div className={cn(classes.bottomLeft, classes.box)}>
              <div className="bold">Students</div>
              {formatNumber(teacher.studentCount, '0,0')}
            </div>
            <div className={cn(classes.bottomRight, classes.box)}>
              <div className="bold">Reviews</div>
              {formatNumber(teacher.reviewCount, '0,0')}
            </div>
          </div>
        </Col>
      </Row>
      <div className={classes.discountInfo}>
        {isRenderDiscount && (
          <span>
            Fee Discount {feeDiscount}% | {feeDiscountRemaining} Schedules remained | Expire {feeDiscountExpired}
          </span>
        )}{' '}
        <a onClick={() => setFeeModal(true)}>
          <AntIcon type="edit" /> Edit Discount
        </a>
      </div>
      {teacher.remark && (
        <Row>
          <Col xs={24}>
            <span className="bold"> Remark: </span>
            <span className="remark-text">{teacher.remark}</span>
          </Col>
        </Row>
      )}

      {Tabs}

      <DiscountTeacherModal handleCancel={() => setFeeModal(false)} isOpen={isShowFeeModal} teacher={teacher} reload={reload}></DiscountTeacherModal>
    </div>
  );
};

export default Form.create()(TeacherHeader);
